var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSocialLinkedinIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#2A2A2A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9756 45.3516H21.282V23.3702H13.9756V45.3516Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5814 20.3687H17.629C20.1769 20.3687 21.7626 18.6809 21.7626 16.5715C21.715 14.4145 20.1769 12.7734 17.6776 12.7734C15.1782 12.7734 13.5439 14.4145 13.5439 16.5715C13.5439 18.6809 15.1296 20.3687 17.5814 20.3687Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3217 45.3516H47.6272V32.7475C47.6272 25.9959 44.0228 22.8543 39.2158 22.8543C35.3394 22.8543 33.6022 24.9847 32.6313 26.4825V23.3702H25.3254C25.4211 25.4324 25.3254 45.3516 25.3254 45.3516H32.6313V33.0762C32.6313 32.4193 32.6785 31.7628 32.8716 31.2932C33.3999 29.9808 34.602 28.6212 36.6203 28.6212C39.2639 28.6212 40.3217 30.6367 40.3217 33.5921V45.3516Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialLinkedinIcon);
export default __webpack_public_path__ + "static/media/social-linkedin-icon.434c48012d9b2a926617a2e0f07daa8c.svg";
export { ForwardRef as ReactComponent };